(() => {
 if (window.tdtProjectsGridLoaded) return;
 window.tdtProjectsGridLoaded = true;
 function init(root) {
  if (root.dataset.projectsReady) return;
  root.dataset.projectsReady = 'true';
  const cards = [...root.querySelectorAll('[data-project]')];
  const filters = root.querySelector('.tdt-projects__filters');
  const status = root.querySelector('.tdt-projects__status');
  const grid = root.querySelector('.tdt-projects__grid');
  if (!filters || !grid || !cards.length) return;
  const cardTags = cards.map(card => new Set([...card.querySelectorAll('.tdt-projects__tag')].map(tag => tag.textContent.trim()).filter(Boolean)));
  const labels = [...new Set(cardTags.flatMap(tags => [...tags]))];
  if (!labels.length) return;
  filters.replaceChildren();
  grid.id = root.id + '-grid';
  const button = (label, value) => {
   const el = document.createElement('button');
   el.type = 'button'; el.className = 'tdt-projects__filter';
   el.textContent = label; el.dataset.filter = value;
   el.setAttribute('aria-pressed', value === '' ? 'true' : 'false');
   el.setAttribute('aria-controls', grid.id);
   filters.append(el); return el;
  };
  button(root.dataset.allLabel || '', '');
  labels.forEach(label => button(label, label));
  filters.hidden = false;
  filters.addEventListener('click', event => {
   const selected = event.target.closest('.tdt-projects__filter');
   if (!selected || !filters.contains(selected)) return;
   const value = selected.dataset.filter;
   cards.forEach((card, i) => { card.hidden = value !== '' && !cardTags[i].has(value); });
   filters.querySelectorAll('button').forEach(el => el.setAttribute('aria-pressed', String(el === selected)));
   status.textContent = cards.filter(card => !card.hidden).length + ' ' + (root.dataset.countLabel || '') + ' · ' + selected.textContent;
  });
 }
 function scan(scope) {
  if (scope.matches?.('[data-tdt-projects]')) init(scope);
  scope.querySelectorAll('[data-tdt-projects]').forEach(init);
 }
 if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => scan(document), { once: true }); else scan(document);
 document.addEventListener('shopify:section:load', event => scan(event.target));
 document.addEventListener('shopify:block:select', event => {
  const root = event.target.closest('[data-tdt-projects]');
  if (!root) return;
  root.querySelectorAll('[data-project]').forEach(card => { card.hidden = false; });
  root.querySelectorAll('.tdt-projects__filter').forEach(el => el.setAttribute('aria-pressed', String(el.dataset.filter === '')));
 });
})();
